import {Model} from "@/app/Model";
import {Utils} from "@/app/Utils";
import {User} from "@/app/data/User";
import {PenaleData} from "@/app/data/PenaleData";
import { TestoResult } from "./data/TestoResult";
import {TestoData} from "@/app/data/TestoData";
import {PenaleAdminComms} from "@/app/admin/PenaleAdminComms";

declare let frontendConfig: any;
declare let returnedToken: string;
declare let gtagO: Function;

export class Comms {
    static baseUrl: string =  ""; //"http://localhost:340"; //deve essere "" se non dev
    static baseLoadTimeout: number = 100;
    protected static instance: Comms;
    static listAllDone: boolean = false;

    //---------------------------------
    public continueFunction: Function | null = null;
    protected inChiamataLogin: boolean = false;
    protected inChiamataCapo_imputazione_legge: boolean = false;
    protected inChiamataCapo_imputazione_legge_by_id: boolean = false;
    protected inChiamataCitta: boolean = false;
    protected inChiamataGiudici: boolean = false;
    protected inChiamataDashboard: boolean = false;
    protected inChiamataPercorso: boolean = false;
    protected inChiamataDejure: boolean = false;
    protected inchiamataAuth: boolean = false;

    public penaleAdmin: PenaleAdminComms = PenaleAdminComms.getInstance();

    protected constructor() {
        //keep it protected to help with the singleton instance
    }

    public static getInstance(): Comms {
        if (!Comms.instance) {
            Comms.instance = new Comms();
        }
        return Comms.instance;
    }

    //---------------------------------
    public setup(): void {
        this.penaleAdmin.comms = this;

        //setup hf + login
        this.hf_setup();
        //setup data
        setTimeout( ()=> {
           // this.listAll(()=> {
                //end preload
                const preloaderDiv: HTMLElement | null = document.getElementById("preloader");
                if (preloaderDiv) preloaderDiv.style.display = "none";
                const appDiv: HTMLElement | null = document.getElementById("app");
                if (appDiv) appDiv.style.display = "block";
                Model.pen_setupped = true;
          //  });
        }, 1000)
    }

    //---------------------------------
    //HEADER FEDERATO + LOGIN
    //hf setup
    protected hf_setup(): void {
        let model: Model = Model.getReactiveInstance();
        model.returnedToken = returnedToken;
        model.user.ticketSso = returnedToken;
        window.addEventListener('message', function (event) {
            if (event.data.task === 'autologin' || event.data.task === 'gethfticket')
            {
                console.log(" ******** HF MESSAGE #C", event.data)
                var token = event.data.params.ticket;
                if (token && token != "") {
                    Comms.hf_doLogin(token);
                } else {
                    Comms.hf_doLogout();
                }
            }
        });
    }
    //hf actions
    static hf_doLogin(tkn: string): void {
        let model: Model = Model.getReactiveInstance();
        model.returnedToken = tkn
        model.user.ticketSso = tkn;
        Comms.listAllDone = false;
        //localStorage.setItem("lastGoodToken", tkn);
        Comms.hf_decodeToken((e:boolean)=>{});
    }
    static hf_doLogout() : void{
        let model: Model = Model.getReactiveInstance();
        model.returnedToken = "";
        model.user = new User();
        model.abbonatoDejure = false;
        model.abbonatoPenale = false;
        model.abbonatoFamiglia = false;
        model.abbonatoResponsabilita = false;
        model.isAdmin = false;
        localStorage.setItem("lastGoodToken", '');
        Comms.listAllDone = false;
    }
    static hf_isNotLogged() : boolean{
        let model: Model = Model.getReactiveInstance();
        let isLogged : boolean = true;
        if (model.returnedToken=="") isLogged = false;
        return !isLogged;
    }
    static hf_decodeToken(callback: Function): void {
        let comms: Comms = Comms.getInstance();
        let model: Model = Model.getReactiveInstance();
        let inDebug: boolean = false;
        if (!comms.inchiamataAuth) {
            comms.inchiamataAuth = true;
            if (!model.returnedToken || (model.returnedToken && model.returnedToken == "")) {
                comms.inchiamataAuth = false;
                callback(false);
            } else if (model.returnedToken && model.returnedToken != "") {
                let commander = "comms_decodeToken";
                let endpoint = "/api/v1/auth";
                let payload = {"ticket": model.returnedToken};
                let options = {
                    method: "POST",
                    headers: {"accept": "application/json", "Content-Type": "application/json"},
                    body: JSON.stringify(payload)
                }
                if (inDebug) console.log("comms_decodeToken CALL", endpoint, options, commander);
                comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);

                function errorCallback(esito:IEsito) {
                    if (inDebug) console.log("comms_decodeToken RESPONSE ERR", esito);
                    comms.inchiamataAuth = false;
                    alert("ATTENZIONE! " + "Non è possibile effettuare il login con le credenziali indicate. Riprovare.");
                    console.log('%c ERROR! ', 'background: #990000; color: #FFFFFF', "Ticket SSO non valido", esito)
                    Comms.hf_doLogout();
                }

                function innerCallback(esito:IEsito) {
                    let response = esito.response;
                    comms.inchiamataAuth = false;
                    if (response) {
                        if (inDebug) console.log("comms_decodeToken RESPONSE OK", response);
                        if (response != undefined && response != null && response.profile != undefined && response.profile != null) {
                            model.user.profile = response.profile;
                            model.user.jwt = response.jwt;
                            model.user.expiration = response.expiration;
                            model.user.ticketSso = model.returnedToken;
                            model.user.crmid = response.profile.crmId;
                            //console.log("comms_decodeToken RESPONSE OK", response, model.user);
                            model.abbonatoDejure = Comms.hf_checkIfUserIsAbbonatoDejure(model.user);
                            model.abbonatoPenale = Comms.hf_checkIfUserIsAbbonatoPenale(model.user);
                            model.abbonatoFamiglia = Comms.hf_checkIfUserIsAbbonatoFamiglia(model.user);
                            model.abbonatoResponsabilita = Comms.hf_checkIfUserIsAbbonatoResponsabilita(model.user);
                            model.isAdmin = Comms.hf_checkIfUserIsAdmin(model.user);
                            localStorage.setItem("lastGoodToken", model.returnedToken);

                            gtagO({
                                'event': 'login',
                                'crmid': model.user.crmid,
                                'tipoLogin': 'manuale',
                                'abbonatoDejure': model.abbonatoDejure
                            });

                            //if (!Comms.listAllDone) {
                            //    //@ts-ignore
                            //    comms.listAll(()=> { if (callback) callback(true); });
                            //} else {
                            //    if (callback) callback(true);
                            //}
                            if (callback) callback(true);
                        } else {
                            Comms.hf_doLogout();
                            alert("ATTENZIONE! " + "Non è possibile al momento effettuare il login con le credenziali indicate. Riprovare più tardi.");
                            console.log('%c ATTENZIONE! ', 'background: #990000; color: #FFFFFF', "Non è possibile al momento effettuare il login con le credenziali indicate. Riprovare più tardi.")
                            if (callback) callback(false);
                        }
                    } else {
                        Comms.hf_doLogout();
                        alert("ATTENZIONE! " + "Non è possibile attualmente effettuare il login con le credenziali indicate. Riprovare più tardi.");
                        console.log('%c ATTENZIONE! ', 'background: #990000; color: #FFFFFF', "Non è possibile attualmente effettuare il login con le credenziali indicate. Riprovare più tardi.")
                        if (callback) callback(false);
                    }
                }
            } else {
                comms.inchiamataAuth = false;
                if (callback) callback(false);
            }
        }
    }
    static hf_checkIfUserIsAbbonatoDejure(user: User): boolean {
        let isAbbonato: boolean = false;
        //condizioni per calcolare model.abbonatoDejure dal profile
        let conditionsEqual: string[] = frontendConfig.rolesDejureCheckLoginEqual; //"materia0"
        let conditionsContains: string[] = frontendConfig.rolesDejureCheckLoginContains;
        //verifica condizioni
        if (user.profile && user.profile.roles && user.profile.roles.length > 0) {
            user.profile.roles.forEach( (role:any) => {
                //ho role.pos (stringa)
                if (conditionsEqual.indexOf(role.pos)>= 0) {
                    isAbbonato = true;
                } else {
                    conditionsContains.forEach( (cont: string)=> {
                        if (role.pos.indexOf(cont) >= 0) isAbbonato = true;
                    })
                }
            })
        }
        return isAbbonato;
    }
    static hf_checkIfUserIsAbbonatoPenale(user: User): boolean {
        let isAbbonato: boolean = false;
        //condizioni per calcolare model.abbonatoPenale dal profile
        let conditionsEqual: string[] = frontendConfig.rolesPenaleCheckLoginEqual; //"ModuloPenale"
        let conditionsContains: string[] = frontendConfig.rolesPenaleCheckLoginContains;
        //verifica condizioni
        if (user.profile && user.profile.roles && user.profile.roles.length > 0) {
            user.profile.roles.forEach( (role:any) => {
                //ho role.pos (stringa)
                if (conditionsEqual.indexOf(role.pos)>= 0) {
                    isAbbonato = true;
                } else {
                    conditionsContains.forEach( (cont: string)=> {
                        if (role.pos.indexOf(cont) >= 0) isAbbonato = true;
                    })
                }
            })
        }
        return isAbbonato;
    }
    static hf_checkIfUserIsAbbonatoFamiglia(user: User): boolean {
        let isAbbonato: boolean = false;
        //condizioni per calcolare model.abbonatoFamiglia dal profile
        let conditionsEqual: string[] = frontendConfig.rolesFamigliaCheckLoginEqual; //"ModuloFamiglia"
        let conditionsContains: string[] = frontendConfig.rolesFamigliaCheckLoginContains;
        //verifica condizioni
        if (user.profile && user.profile.roles && user.profile.roles.length > 0) {
            user.profile.roles.forEach( (role:any) => {
                //ho role.pos (stringa)
                if (conditionsEqual.indexOf(role.pos)>= 0) {
                    isAbbonato = true;
                } else {
                    conditionsContains.forEach( (cont: string)=> {
                        if (role.pos.indexOf(cont) >= 0) isAbbonato = true;
                    })
                }
            })
        }
        return isAbbonato;
    }
    static hf_checkIfUserIsAbbonatoResponsabilita(user: User): boolean {
        let isAbbonato: boolean = false;
        //condizioni per calcolare model.abbonatoResponsabilita dal profile
        let conditionsEqual: string[] = frontendConfig.rolesResponsabilitaCheckLoginEqual; //"ModuloResponsabilita"
        let conditionsContains: string[] = frontendConfig.rolesResponsabilitaCheckLoginContains;
        //verifica condizioni
        if (user.profile && user.profile.roles && user.profile.roles.length > 0) {
            user.profile.roles.forEach( (role:any) => {
                //ho role.pos (stringa)
                if (conditionsEqual.indexOf(role.pos)>= 0) {
                    isAbbonato = true;
                } else {
                    conditionsContains.forEach( (cont: string)=> {
                        if (role.pos.indexOf(cont) >= 0) isAbbonato = true;
                    })
                }
            })
        }
        return isAbbonato;
    }

    static hf_checkIfUserIsAdmin(user: User): boolean {
        let isAdmin: boolean = false;
        if (user.profile && user.profile.userId && user.profile.userId != "") {
            if (frontendConfig.adminUser.indexOf(user.profile.userId) >= 0) isAdmin = true;
        }
        return isAdmin
    }
    //? remove
    public doLoginByToken(callback: Function | null = null): void {
        //FATTIBILE LOGIN? NO...
        if (callback) callback();
    }

    //---------------------------------
    //BUSINESS
    //setup lists
    public listAll(callback: Function | null = null): void {
        this.listCapo_imputazione_legge((e: IEsito) => {
            this.listCitta((e: IEsito) => {
                this.listGiudici((e: IEsito) => {
                    Comms.listAllDone = true;
                    setTimeout( ()=> {postMessage("listAllRefresh")}, 2000);
                    if (callback) callback();
                })
            })
        })
    }
    public listCapo_imputazione_legge(callback: Function | null = null): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.listCapo_imputazione_legge;
            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }
        let model: Model = Model.getReactiveInstance();
        if (!this.inChiamataCapo_imputazione_legge) {
            this.inChiamataCapo_imputazione_legge = true;
            model.lista_capo_imputazione_legge = [];
            let commander: string = "listCapo_imputazione_legge";
            let endpoint: string = "/graphql";
            let payload = {
                query: `{
                    pgQuery(
                         input: {
                            name: "lista_capo_imputazione_legge"
                            params: { }
                         }
                    ) {
                         list
                         record
                    }
                }`,
                variables: {},
                operationName: null,
            };
            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };
            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => {
            };
            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataCapo_imputazione_legge = false;
                if (esito.response && esito.response.data && esito.response.data.pgQuery && esito.response.data.pgQuery.list) {
                    model.lista_capo_imputazione_legge = esito.response.data.pgQuery.list;
                }
                if (callback) callback(esito);
            };
            this.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }

    public getAnalisiViewData( id_doc_master: number, callback: Function | null = null): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.getAnalisiViewData;
            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);

            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();

        if (!this.inChiamataCapo_imputazione_legge_by_id) {
            this.inChiamataCapo_imputazione_legge_by_id = true;

            let innerParams: string = 'id_doc_master:' + id_doc_master;
            let params: string = `{${innerParams}}`;

            let commander: string = "get_campo_principale_by_id";
            let endpoint: string = "/graphql";
            let payload = {
                query: `{
                    pgQuery(
                         input: {
                            name: "get_campo_principale_by_id"
                            params: ${params}
                         }
                    ) {
                         list
                         record
                    }
                }`,
                variables: {},
                operationName: null,
            };

            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };
            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };

            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataCapo_imputazione_legge_by_id = false;
                if (callback) callback(esito);
            };

            this.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }

    public listCitta(callback: Function | null = null): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.listCitta;
            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }
        let model: Model = Model.getReactiveInstance();
        if (!this.inChiamataCitta) {
            this.inChiamataCitta = true;
            model.pen_lista_citta = [];
            let commander: string = "pen_listCitta";
            let endpoint: string = "/graphql";
            let payload = {
                query: `{
                    pgQuery(
                         input: {
                            name: "pen_lista_citta"
                            params: { }
                         }
                    ) {
                         list
                         record
                    }
                }`,
                variables: {},
                operationName: null,
            };
            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };
            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => {
            };
            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataCitta = false;
                if (esito.response && esito.response.data && esito.response.data.pgQuery && esito.response.data.pgQuery.list) {
                    model.pen_lista_citta = esito.response.data.pgQuery.list;
                }
                if (callback) callback(esito);
            };
            this.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }
    public listGiudici(callback: Function | null = null): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.listGiudici;
            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }
        let model: Model = Model.getReactiveInstance();
        if (!this.inChiamataGiudici) {
            this.inChiamataGiudici = true;
            model.pen_lista_giudici = [];
            let commander: string = "pen_listGiudici";
            let endpoint: string = "/graphql";
            let payload = {
                query: `{
                    pgQuery(
                         input: {
                            name: "pen_lista_giudici"
                            params: { }
                         }
                    ) {
                         list
                         record
                    }
                }`,
                variables: {},
                operationName: null,
            };
            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };
            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => {
            };
            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataGiudici = false;
                if (esito.response && esito.response.data && esito.response.data.pgQuery && esito.response.data.pgQuery.list) {
                    model.pen_lista_giudici = esito.response.data.pgQuery.list;
                }
                if (callback) callback(esito);
            };
            this.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }

    //query dashboard
    public queryDashboard(callback: Function | null = null, soloPaginazione: boolean = false): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.queryDashboard;
            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }
        let model: Model = Model.getReactiveInstance();
        if (!this.inChiamataDashboard) {
            this.inChiamataDashboard = true;
            if (!soloPaginazione) model.pen_get_dashboard = new PenaleData();
            let commander: string = "queryDashboard";
            let endpoint: string = "/graphql";
            let innerParams: string = "";
            let innerGrafici: number[] = [];
            if (model.pen_flow_dashboard.capo_imputazione_legge != "" && model.pen_flow_dashboard.capo_imputazione_legge != " ")  {
                innerParams += 'capo_imputazione_legge:["' + model.pen_flow_dashboard.capo_imputazione_legge.replace(/'/g, "''") + '"] ';
            } //ARRAY       
            if (model.pen_flow_dashboard.importo_evaso_active)  {
                innerParams += 'importo_evaso_da:' + model.pen_flow_dashboard.importo_evaso_da + ' ';
                innerParams += 'importo_evaso_a:' + model.pen_flow_dashboard.importo_evaso_a + ' ';
            }
            if (model.pen_flow_dashboard.assoluzione != "")  {
                innerParams += 'tipo_assoluzione:"' + model.pen_flow_dashboard.assoluzione.replace(/'/g, "''") + '" ';
            }
            if (model.pen_flow_dashboard.assoluzione_motivo != "")  {
                innerParams += 'assoluzione_motivo:["' + model.pen_flow_dashboard.assoluzione_motivo.replace(/'/g, "''") + '"] ';
            } //ARRAY
            if (model.pen_flow_dashboard.pena_principale != "")  {
                innerParams += 'pena_principale:["' + model.pen_flow_dashboard.pena_principale.replace(/'/g, "''") + '"] ';
            } //ARRAY
            if (model.pen_flow_dashboard.importo_risarcimento_active)  {
                innerParams += 'importo_risarcimento_da:' + model.pen_flow_dashboard.importo_risarcimento_da + ' ';
                innerParams += 'importo_risarcimento_a:' + model.pen_flow_dashboard.importo_risarcimento_a + ' ';
            }
            if (model.pen_flow_dashboard.id_localita != "")  {
                innerParams += 'id_localita:"' + model.pen_flow_dashboard.id_localita.replace(/'/g, "''") + '" ';
            }
            if (model.pen_flow_dashboard.durata_del_processo_active)  {
                innerParams += 'durata_del_processo:' + model.pen_flow_dashboard.durata_del_processo + ' ';
            }
            if (model.pen_flow_dashboard.non_menzione_nel_casellario === true)  {
                innerParams += 'non_menzione_nel_casellario: true ';
            }
            if (model.pen_flow_dashboard.giudice != "")  {
                innerParams += 'giudice:["' + model.pen_flow_dashboard.giudice.replace(/'/g, "''") + '"] ';
            } //ARRAY
            if (model.pen_flow_dashboard.data_pronuncia_sentenza_active)  {
                let dataDa: Date = new Date(model.pen_flow_dashboard.data_pronuncia_sentenza_da + "-1-1");
                dataDa.setHours(0,0,0, 0);
                let dataA: Date = new Date( model.pen_flow_dashboard.data_pronuncia_sentenza_a + "-12-31");
                dataA.setHours(23,59,59, 999);
                let dataDaIso: string = dataDa.toISOString();
                let dataDaIsoSpl: string[] = dataDaIso.split("T");
                let dataAIso: string = dataA.toISOString();
                let dataAIsoSpl: string[] = dataAIso.split("T");
                innerParams += 'data_pronuncia_sentenza_da:"' + dataDaIsoSpl[0] + '" ';
                innerParams += 'data_pronuncia_sentenza_a:"' + dataAIsoSpl[0] + '" ';
            }
            if (model.pen_flow_dashboard.durata_pena_active)  {
                innerParams += 'durata_pena:[' + model.pen_flow_dashboard.durata_pena + '] ';
            }  //ARRAY ???

            if (model.pen_flow_dashboard.durata_del_processo_notNull === true)  {
                innerParams += 'durata_del_processo_not_null: "true" ';
            } else {
                innerParams += 'durata_del_processo_not_null: "false" ';
            }
            if (model.pen_flow_dashboard.durata_pena_notNull === true)  {
                innerParams += 'durata_pena_not_null: "true" ';
            } else {
                innerParams += 'durata_pena_not_null: "false" ';
            }

            if (model.pen_flow_dashboard.paginazione_start > 0) {
                innerParams += 'start:' + Math.floor(model.pen_flow_dashboard.paginazione_start * model.pen_flow_dashboard.paginazione_rows).toFixed(0) + ' ';
            }

            let params: string = `{ ${innerParams} }`; //da model.pen_flow_dashboard capo_imputazione_legge: ["art. 10-ter D.Lgs. n. 74 del 2000"] grafico: [4]
            let payload = {
                query: `{
                  pgQuery(
                     input: {
                        name: "pen_get_dashboard"
                        params: ${params}
                     }
                  ) {
                     list
                  }
               }`,
                variables: {},
                operationName: null,
            };

            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };
            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };

            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataDashboard = false;
                if (soloPaginazione) {
                    let useJson: any = esito.response.data.pgQuery.list[0].result;
                    if (useJson["sentenze_paginate"]) model.pen_get_dashboard.sentenze_paginate = useJson["sentenze_paginate"]; //aggiorno solo dati relativi a paginazione in model.pen_get_dashboard
                    if (useJson["sentenze_paginate_jump"]) {
                        model.pen_get_dashboard.sentenze_paginate_jump = useJson["sentenze_paginate_jump"];
                        model.pen_get_dashboard.sentenze_paginate_jump_display = model.pen_get_dashboard.sentenze_paginate_jump.slice(0, model.pen_flow_dashboard.diritto_paginazione_rows);
                    }
                    model.pen_flow_dashboard.diritto_paginazione_start = 0;
                    model.pen_flow_dashboard.diritto_paginazione_tot = model.pen_get_dashboard.sentenze_paginate_jump.length;
                    model.pen_flow_dashboard.diritto_paginazione_pages = Math.ceil(model.pen_flow_dashboard.diritto_paginazione_tot / model.pen_flow_dashboard.diritto_paginazione_rows) -1;
                } else {
                    model.pen_get_dashboard = new PenaleData(esito.response);
                }

                // gtagO({
                //     'event': 'ricerca', 
                //     'tipoRicerca': 'ricerca generale penale', 
                //     'testoCercato': JSON.stringify(payload), 
                //     'risultati': model.pen_get_dashboard.totale_numero_sentenze.valore
                // });

                if (callback) callback(esito);
            };
            this.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }
    //query percorso
    public queryPercorso(callback: Function | null = null, soloPaginazione: boolean = false): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.queryPercorso;
            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }
        let model: Model = Model.getReactiveInstance();
        if (!this.inChiamataPercorso) {
            this.inChiamataPercorso = true;
            if (!soloPaginazione) model.pen_get_percorso = new PenaleData();
            let commander = "queryPercorso";
            let endpoint: string = "/graphql";
            let innerParams: string = "";
            let innerGrafici: number[] = [];
            if (model.pen_flow_percorso.capo_imputazione_legge != "" && model.pen_flow_percorso.capo_imputazione_legge != " ")  {
                innerParams += 'capo_imputazione_legge:["' + model.pen_flow_percorso.capo_imputazione_legge.replace(/'/g, "''") + '"] ';
                innerGrafici.push(4);
            } //ARRAY
            if (model.pen_flow_percorso.importo_evaso_active === true)  {
                innerParams += 'importo_evaso_da:' + model.pen_flow_percorso.importo_evaso_da + ' ';
                innerParams += 'importo_evaso_a:' + model.pen_flow_percorso.importo_evaso_a + ' ';
                if (innerGrafici.indexOf(7)<0)  innerGrafici.push(7);
            }
            if (model.pen_flow_percorso.assoluzione != "")  {
                innerParams += 'tipo_assoluzione:["' + model.pen_flow_percorso.assoluzione.replace(/'/g, "''") + '"] ';
                innerGrafici.push(10);
                innerGrafici.push(6);
            }
            if (model.pen_flow_percorso.assoluzione_motivo != "")  {
                innerParams += 'assoluzione_motivo:["' + model.pen_flow_percorso.assoluzione_motivo.replace(/'/g, "''") + '"] ';
                if (innerGrafici.indexOf(10)<0) innerGrafici.push(10);
            } //ARRAY
            if (model.pen_flow_percorso.pena_principale != "")  {
                innerParams += 'pena_principale:["' + model.pen_flow_percorso.pena_principale.replace(/'/g, "''") + '"] ';
                if (innerGrafici.indexOf(6)<0) innerGrafici.push(6);
            } //ARRAY

            if (model.pen_flow_percorso.paginazione_start > 0) {
                innerParams += 'start:' + Math.floor(model.pen_flow_percorso.paginazione_start * model.pen_flow_percorso.paginazione_rows).toFixed(0) + ' ';
            }

            innerParams += 'durata_del_processo_not_null: "false" ';
            innerParams += 'durata_pena_not_null: "false" ';

            if (innerGrafici.length > 0) {
                if (innerGrafici.indexOf(1)<0) {
                    innerGrafici.push(1);
                }
                if (innerGrafici.indexOf(7)<0) {
                    innerGrafici.push(7);
                }
                if (innerGrafici.indexOf(14)<0) {
                    innerGrafici.push(14);
                }
                innerParams += 'grafico:[' + innerGrafici.join(",") + ']';
            }
            let params: string = `{ ${innerParams} }`; //da model.pen_flow_percorso capo_imputazione_legge: ["art. 10-ter D.Lgs. n. 74 del 2000"] grafico: [4]
            let payload = {
                query: `{
                  pgQuery(
                     input: {
                        name: "pen_get_dashboard"
                        params: ${params}
                     }
                  ) {
                     list
                  }
               }`,
                variables: {},
                operationName: null,
            };
            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };
            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };
            
            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataPercorso = false;
                if (soloPaginazione) {
                    let useJson: any = esito.response.data.pgQuery.list[0].result;
                    if (useJson["sentenze_paginate"]) model.pen_get_percorso.sentenze_paginate = useJson["sentenze_paginate"]; //aggiorno solo dati relativi a paginazione in model.pen_get_percorso
                    if (useJson["sentenze_paginate_jump"]) {
                        model.pen_get_percorso.sentenze_paginate_jump = useJson["sentenze_paginate_jump"];
                        model.pen_get_percorso.sentenze_paginate_jump_display = model.pen_get_percorso.sentenze_paginate_jump.slice(0, model.pen_flow_percorso.diritto_paginazione_rows);
                    }
                    model.pen_flow_percorso.diritto_paginazione_start = 0;
                    model.pen_flow_percorso.diritto_paginazione_tot = model.pen_get_percorso.sentenze_paginate_jump.length;
                    model.pen_flow_percorso.diritto_paginazione_pages = Math.ceil(model.pen_flow_percorso.diritto_paginazione_tot / model.pen_flow_percorso.diritto_paginazione_rows) -1;
                } else {
                    model.pen_get_percorso = new PenaleData(esito.response);
                }

                // gtagO({
                //     'event': 'ricerca', 
                //     'tipoRicerca': 'ricerca generale penale', 
                //     'testoCercato': JSON.stringify(payload), 
                //     'risultati':model.pen_get_percorso.totale_numero_sentenze.valore
                // });

                if (callback) callback(esito);
            };
            this.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }
    //dejure
    public callDejure(ids: number[] = [], callback?: Function): void {
        let model: Model = Model.getReactiveInstance();
        let token: string = model.returnedToken; //"AQIC5wM2LY4SfcwohGWOA30RUQd7mHXhPtUXF3XcvqjHseI.*AAJTSQACMDEAAlNLABM4MTgyNTM1NDgxMDk4MDM3NDgyAAJTMQAA*";
        let urlDejureSave: string = frontendConfig.urlDejureSave; //"https://gflapi-pre.giuffre.it/api/ModuloStrategia";
        let databankDejureSave: number = frontendConfig.databankDejureSave; //2;
        let urlDejureOpen: string = frontendConfig.urlDejureOpen+token; // "https://dejure-pre.giuffre.it/#/home?moduloStrategia=true&ticket="+token;
        //---
        let that: Comms = this;
        //console.log("CHIAMO DEJURE",(!this.inChiamataDejure && ids.length > 0), ids)
        if (!this.inChiamataDejure && ids.length > 0) {
            this.inChiamataDejure = true;
            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "Token": token,
                    "IdDatabank": databankDejureSave,
                    "IdDocMasterList": ids
                }),
            };
            
            fetch(urlDejureSave, options)
                .then((res: Response) => {
                    that.inChiamataDejure = false;
                    if (res.ok) {
                        return res.json();
                    } else {
                        if (callback) callback();
                        alert("ERRORE IN APERTURA DEJURE")
                    }
                })
                .then((response) => {
                    that.inChiamataDejure = false;
                    
                    if (response != undefined && response != null) {
                        // gtagO({event: 'outboundlink', url: urlDejureOpen})

                        window.open( urlDejureOpen, "_blank");
                    } else {
                        alert("ERRORE DI SALVATAGGIO SU DEJURE")
                    }
                    if (callback) callback();
                    //alla fine
                })
                .catch((err) => {
                    that.inChiamataDejure = false;
                    if (callback) callback();
                    alert("ERRORE IN CHIAMATA DEJURE")
                });
        } else {
            if (callback) callback();
        }
    }
    public openDettaglioDejure(id_doc_master: number = -1, id_databanks: number = -1, id: string = ""): void {
        let model: Model = Model.getReactiveInstance();
        let detailUrl: string = frontendConfig.urlDejureDetail.replace('{{id_doc_master}}', id_doc_master).replace('{{id}}', id).replace('{{id_databanks}}', id_databanks);
        detailUrl += model.returnedToken;

        // gtagO({event: 'outboundlink', url: detailUrl})

        window.open(detailUrl, "_blank");
    }
    public openDettaglioModal(id_doc_master: number = -1, id_databanks: number = -1, id: string = ""): void {
        let model: Model = Model.getReactiveInstance();
        model.testo_result = new TestoResult();
        model.testo_data = new TestoData();
        model.testo_data.id_doc_master = id_doc_master; //popolare altri parametri di model.testo_data ? tipo_testo = 2;   id_unita_doc =  0; tipo_ud = 0;
        //apre modale
        document.getElementById("triggerModalDettaglio")?.click();
        //chiamata
        this.queryGetTesto( () => {} );
    }
    //query testo dettaglio
    public queryGetTesto(callback: Function | null = null): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.queryGetTesto;

            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);

            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();
        model.testo_result = new TestoResult();
        if (model.testo_data.id_doc_master) {
            let commander: string = "queryGetTesto";
            let endpoint: string = "/graphql";
            let innerParams: string = "";

            innerParams += 'id_doc_master:' + model.testo_data.id_doc_master + ' ';
            
            if (model.testo_data.tipo_testo)  {
                innerParams += 'tipo_testo:' + model.testo_data.tipo_testo + ' ';
            }
            if (model.testo_data.id_unita_doc)  {
                innerParams += 'id_unita_doc:' + model.testo_data.id_unita_doc + ' ';
            }
            if (model.testo_data.tipo_ud)  {
                innerParams += 'tipo_ud:' + model.testo_data.tipo_ud + ' ';
            }

            let params: string = `{ ${innerParams} }`;
            let payload = {
                query: `{
                  pgQuery(
                     input: {
                        name: "api_get_testo"
                        params: ${params}
                     }
                  ) {
                     list
                  }
               }`,
                variables: {},
                operationName: null,
            };

            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };
            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };

            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);

                model.testo_result = new TestoResult(esito.response);

                gtagO({ 'event': 'getTesto', 'testoCercato': JSON.stringify(payload)});

                if (callback) callback(esito);
            };
            
            this.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }
    //sintetizza
    public openSintesi(page: string, id: number, params: ISintesiParams): void {
        let urlSintesi: string = frontendConfig.urlSintesi.replace('{{idDocMaster}}', params.id_doc_master.toString()).replace('{{username}}', params.username).replace('{{crmid}}', params.crmid);
        //console.log("SINTETIZZO CON AI", page, id, params, urlSintesi);
        // Trova la riga di riferimento
        const referenceRow: HTMLElement | null = document.getElementById('docRiga-'+page+'-'+id);
        let newRowId: string = 'docRiga2-'+page+'-'+id;
        const referenceRow2: HTMLElement | null = document.getElementById(newRowId);
        if (!referenceRow2) {
            if (referenceRow) {
                const newRow = document.createElement('tr');
                newRow.id = newRowId;
                const newCell = document.createElement('td');
                newCell.colSpan = 3;
                newCell.classList.add("rigaSintetizza");
                newCell.innerHTML = `<div class="accordion" id="accordion-${page}-${id}">
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-${page}-${id}" aria-expanded="true" aria-controls="collapse-${page}-${id}">
        SINTESI
      </button>
    </h2>
    <div id="collapse-${page}-${id}" class="accordion-collapse collapse show" data-bs-parent="#accordion-${page}-${id}">
      <div class="accordion-body">
        <iframe src="${urlSintesi}" class="iframeSintetizza"></iframe>
      </div>
    </div>
  </div>
</div>`;


                // Aggiungi le celle alla nuova riga
                newRow.appendChild(newCell);

                // Inserisci la nuova riga subito dopo la riga di riferimento
                if (referenceRow.parentNode) {
                    referenceRow.parentNode.insertBefore(newRow, referenceRow.nextSibling);
                } else {
                    erroreFun()
                }

            } else {
                erroreFun()
            }
        }

        function erroreFun(): void {
            console.error(`Errore nella sintesi della riga ${id}`);
        }
    }

    //---------------------------------
    //COMMON
    public doFetch(
        endpoint: string,
        options: any,
        commander: string,
        innerCallback: Function,
        errorCallback: Function
    ): void {
        let inDebug: boolean = false;
        let esito: IEsito = {isOk: true, commander: commander, response: null};
        let calledError: boolean = false;
        fetch(Comms.baseUrl + endpoint, options)
            .then((res: Response) => {
                if (inDebug) console.log("doFetch PARSE", res, commander);
                if (res.ok) {
                    return res.json();
                } else {
                    esito.isOk = false;
                    esito.response = res;
                    if (inDebug) console.log("doFetch ERROR", res, commander);
                    if (!calledError)
                        if (errorCallback) {
                            calledError = true;
                            errorCallback(esito);
                        }
                }
            })
            .then((response) => {
                if (inDebug) console.log("doFetch RESPONSE", response, commander);

                let gotData: any = null;
                if (response != undefined && response != null) {
                    if (inDebug) console.log("doFetch OK", response, commander);
                    gotData = response;
                } else {
                    esito.isOk = false;
                }
                esito.response = response;
                if (!gotData) {
                    if (!calledError)
                        if (errorCallback) {
                            calledError = true;
                            errorCallback(esito);
                        }
                }
                if (!calledError) if (innerCallback) innerCallback(esito);
            })
            .catch((err) => {
                console.log(err);
                esito.isOk = false;
                if (errorCallback) errorCallback(esito);
            });
    }
}

export interface IEsito {
    isOk: boolean;
    commander: string;
    response: any
}
export interface ISintesiParams {
    id_doc_master: number;
    username: string;
    crmid: string;
}